import { CheckOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import styled from 'styled-components'

const ApproveBtn = (props) => {
  let {
    loading = false, onClick,
    disabled = false, title = 'OK'
  } = props

  let content
  let click
  if (loading === false) {
    content = <CheckOutlined />
    click = onClick
  }
  return (
    <Page>
      <Tooltip placement="top" title={title}>
        <Button
          shape="circle" disabled={disabled}
          loading={loading} onClick={click}>
          {content}
        </Button>
      </Tooltip>
    </Page>
  )
}

const Page = styled.div`
  button {
    color: #3F3F3F;
    background-color: #dcedc2;

    height: 45px
    width: 45px;
  }

  button > i {
    font-size: 16px;
  }

  button:hover {
    color: #dcedc2;
    background-color: white;
    border-color: #dcedc2;
  }
`

export default ApproveBtn
